import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/SignPunsApi";
import { PRODUCT_CATEGORY_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";
import { formateColumnFilter } from "@/utils/columnFilter";
import { getAllProductCategory } from "../../CatalogSlice";
import ProductCategoryForm from "./ProductCategoryForm";
import "react-toastify/dist/ReactToastify.css";

const ProductCategory = () => {
  const [productCategoryDetails, setProductCategoryDetails] = useState();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteProductCategory, { isLoading: isDeleting }] =
    useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getProductCategoryRecords,
    {
      data: productCategoryList,
      isError: isProductCategoryError,
      isLoading: isProductCategoryLoading,
      isFetching: isProductCategoryFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "Product Name",
      accessor: "Product.Name",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "Category Name",
      accessor: "Category.Name",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
  ];

  const handleEditData = (ProductCategoryData) => {
    setSelectedRecord(ProductCategoryData);
    setIsAddModalOpen(true);
  };

  const handleDelete = () => {
    deleteProductCategory({
      entity: "ProductCategory",
      id: selectedRecord.Id,
      tag: PRODUCT_CATEGORY_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsDeleteModalOpen(!isDeleteModalOpen);
        successToast("Product-Category deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );
    getProductCategoryRecords({
      entity: "ProductCategory",
      expand: { Product: {}, Category: {} },
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: PRODUCT_CATEGORY_TAG,
    });
    setProductCategoryDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (
      !isProductCategoryLoading &&
      !isProductCategoryError &&
      productCategoryList &&
      !isProductCategoryFetching
    ) {
      dispatch(getAllProductCategory(productCategoryList.value));
      let ProductCategoryData = [...productCategoryList.value];
      setProductCategoryDetails({
        ...productCategoryDetails,
        tableRowsData: productCategoryList.value ? ProductCategoryData : [],
        totalData:
          productCategoryList && productCategoryList["@odata.count"]
            ? productCategoryList["@odata.count"]
            : 0,
        onEditClick: (data) => handleEditData(data),
        onDeleteClick: (data) => {
          setIsDeleteModalOpen(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [
    isProductCategoryError,
    productCategoryList,
    isProductCategoryLoading,
    isProductCategoryFetching,
  ]);
  return (
    <Container>
      <Row>
        {productCategoryDetails && (
          <DataReactTable
            reactTableData={productCategoryDetails}
            onAddClick={() => {
              setIsAddModalOpen(true);
              setSelectedRecord();
            }}
            title="Product Category"
            isFetching={isProductCategoryFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isAddModalOpen && (
        <AddModal
          toggle={() => setIsAddModalOpen(!isAddModalOpen)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} Product Category`}
          header
          btn="Success"
          message={
            <ProductCategoryForm
              editData={selectedRecord ? selectedRecord : {}}
              setIsAddModalOpen={setIsAddModalOpen}
            />
          }
        />
      )}
      {isDeleteModalOpen && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete ${selectedRecord.Product.Name}?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default ProductCategory;
